export enum handleRegexType {
    ADD = 'add',
    EDIT = 'edit',
    REMOVE = 'remove'
}
